module.exports = __webpack_public_path__ + "img/ttpush-logo.309e1118.svg";